var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoaderTerminal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    width: 200,
    height: 200,
    style: {
      shapeRendering: "auto",
      display: "block",
      background: "transparent"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#161211",
    r: 11,
    cy: 75,
    cx: 28
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    keyTimes: "0;0.2;1",
    values: "0;1;1",
    dur: "1s",
    repeatCount: "indefinite",
    attributeName: "fill-opacity"
  })), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 10,
    stroke: "#3ca46d",
    fill: "none",
    d: "M28 47A28 28 0 0 1 56 75"
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "0.1s",
    keyTimes: "0;0.2;1",
    values: "0;1;1",
    dur: "1s",
    repeatCount: "indefinite",
    attributeName: "stroke-opacity"
  })), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 10,
    stroke: "#50cd89",
    fill: "none",
    d: "M28 25A50 50 0 0 1 78 75"
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "0.2s",
    keyTimes: "0;0.2;1",
    values: "0;1;1",
    dur: "1s",
    repeatCount: "indefinite",
    attributeName: "stroke-opacity"
  })), /*#__PURE__*/React.createElement("g", null))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderTerminal);
export default __webpack_public_path__ + "static/media/loaderTerminal.6460252adfb9516f5bc6e4064c6ed120.svg";
export { ForwardRef as ReactComponent };